export const MUTATION_KEYS = {
    createMediaPackage: 'create-media-package',
    updateMediaPackage: 'update-media-package',
    removeMediaPackage: 'remove-media-package',
    unlockMedialPackage: 'unlock-media-package'
}

export const QUERY_KEYS = {
    myMediaPackages: 'my-media-packages',
    myMediaPackage: 'my-media-package'
}
